export default "__VITE_ASSET__C26K3l8q__"